import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import TestSingleChoiceFormFeedback from './TestSingleChoiceFormFeedback'
import TestSingleChoiceFormFonts from './TestSingleChoiceFormFont'
import TestSingleChoiceFormStyle from './TestSingleChoiceFormStyle'
import type {
  TestSingleChoiceFormBrandType,
  TestSingleChoiceBrandForms,
} from './testSingleChoiceTypes'

const FORM_MAP: TestSingleChoiceBrandForms = {
  [BrandFormEnum.STYLE]: TestSingleChoiceFormStyle,
  [BrandFormEnum.FEEDBACK]: TestSingleChoiceFormFeedback,
  ...TestSingleChoiceFormFonts,
}

const TestSingleChoiceFormBrand: TestSingleChoiceFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(TestSingleChoiceFormBrand) as typeof TestSingleChoiceFormBrand
